export function createId() {
    const timestamp = Date.now().toString(16).padStart(12, '0');
    const random = typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID().replaceAll('-', '').slice(0, 20)
        : Math.random().toString(16).slice(2).padEnd(20, '0');
    return `${timestamp}-${random}`;
}
export function baseRecord(value) {
    const now = Date.now();
    return { ...value, id: createId(), createdAt: now, updatedAt: now };
}
